module.exports = __webpack_public_path__ + "img/bg_1.608f6377.png";